(function () {
	if (window.CloudMAttribution) {
		return;
	}

	var key = 'cloudm_utm_attribution';
	var fields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term'];
	var maxAge = 90 * 24 * 60 * 60;
	var forms = new Set();
	var disabledInputs = new WeakSet();
	var active = false;
	var consentReady = !!(window.Cookiebot && window.Cookiebot.hasResponse);
	var consentCookie = readCookie('CookieConsent');

	function clean(value) {
		return typeof value === 'string' ? value.replace(/[\u0000-\u001F\u007F]/g, '') : '';
	}

	function readCookie(name) {
		var prefix = name + '=';
		var cookie = document.cookie.split(';').find(function (item) {
			return item.trim().indexOf(prefix) === 0;
		});

		return cookie ? cookie.trim().slice(prefix.length) : '';
	}

	function writeCookie(value, lifetime) {
		try {
			document.cookie = key + '=' + value + '; Path=/; Max-Age=' + lifetime +
				'; SameSite=Lax' + (window.location.protocol === 'https:' ? '; Secure' : '');
		} catch (error) {
			// Attribution is optional when cookies are unavailable.
		}
	}

	function clearLegacyStorage() {
		try {
			window.sessionStorage.removeItem(key);
		} catch (error) {
			// Storage can be disabled by the browser.
		}
	}

	function hasConsent() {
		// Do not trust an older tab's consent after another tab changes it.
		return !!(window.Cookiebot && window.Cookiebot.consent &&
			window.Cookiebot.consent.marketing === true &&
			readCookie('CookieConsent') === consentCookie);
	}

	function hasValues(values) {
		return !!values && fields.some(function (field) {
			return values[field];
		});
	}

	function getStoredValues() {
		try {
			var stored = JSON.parse(decodeURIComponent(readCookie(key)));
			var values = {};

			fields.forEach(function (field) {
				values[field] = clean(stored && stored[field]);
			});

			return hasValues(values) ? values : null;
		} catch (error) {
			return null;
		}
	}

	function captureValues() {
		var params = new URLSearchParams(window.location.search);
		var values = {};

		fields.forEach(function (field) {
			values[field] = clean(params.get(field));
		});

		if (hasValues(values)) {
			var encoded = encodeURIComponent(JSON.stringify(values));
			// Avoid exceeding browser cookie limits or keeping an older campaign.
			writeCookie(encoded.length <= 3800 ? encoded : '', encoded.length <= 3800 ? maxAge : 0);
		}
	}

	function updateConsent() {
		if (!hasConsent()) {
			// Preserve shared cookies until Cookiebot confirms this tab's choice.
			if ((consentReady || active) && readCookie('CookieConsent') === consentCookie) {
				writeCookie('', 0);
			}

			active = false;
			return false;
		}

		if (!active) {
			active = true;
			captureValues();
		}

		return true;
	}

	function getForm($form) {
		if (!$form) {
			return null;
		}

		if ($form.nodeType === 1) {
			return $form.matches('form') ? $form : $form.querySelector('form');
		}

		return typeof $form.get === 'function' ? getForm($form.get(0)) : null;
	}

	function setField(form, field, value, allowed) {
		var inputs = form.querySelectorAll('[name="' + field + '"]');

		if (!inputs.length && allowed) {
			var input = document.createElement('input');
			input.type = 'hidden';
			input.name = field;
			form.appendChild(input);
			inputs = [input];
		}

		inputs.forEach(function (input) {
			if (allowed && disabledInputs.has(input)) {
				input.disabled = false;
				disabledInputs.delete(input);
			} else if (!allowed && !input.disabled) {
				input.disabled = true;
				disabledInputs.add(input);
			}

			input.value = value;
		});
	}

	function setSubmissionValue(submissionValues, field, value, allowed) {
		if (!Array.isArray(submissionValues)) {
			return;
		}

		var found = false;

		for (var index = submissionValues.length - 1; index >= 0; index -= 1) {
			if (submissionValues[index].name === field) {
				if (!allowed) {
					submissionValues.splice(index, 1);
				} else {
					submissionValues[index].value = value;
					found = true;
				}
			}
		}

		if (allowed && !found) {
			submissionValues.push({ name: field, value: value });
		}
	}

	function apply($form, submissionValues) {
		var form = getForm($form);
		var values = updateConsent() ? getStoredValues() : null;

		if (form) {
			forms.add(form);
		}

		fields.forEach(function (field) {
			var value = values ? values[field] : '';

			if (form) {
				setField(form, field, value, !!values);
			}

			setSubmissionValue(submissionValues, field, value, !!values);
		});
	}

	function syncForms() {
		updateConsent();
		forms.forEach(function (form) {
			if (form.isConnected) {
				apply(form);
			} else {
				forms.delete(form);
			}
		});
	}

	['CookiebotOnConsentReady', 'CookiebotOnAccept', 'CookiebotOnDecline'].forEach(function (event) {
		window.addEventListener(event, function () {
			consentReady = true;
			consentCookie = readCookie('CookieConsent');
			clearLegacyStorage();
			syncForms();
		});
	});

	window.addEventListener('focus', syncForms);
	window.addEventListener('pageshow', syncForms);
	clearLegacyStorage();
	updateConsent();

	window.CloudMAttribution = {
		apply: apply
	};
})();
